export function SafetyReasonField(props: {
  label: string;
  value: string;
  onChange(value: string): void;
}): React.JSX.Element {
  return (
    <label>
      {props.label}
      <textarea
        aria-label={props.label}
        maxLength={1000}
        value={props.value}
        onChange={(event) => props.onChange(event.target.value)}
      />
    </label>
  );
}
